"use client";

import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const products = [{
  id: 1,
  name: "Stainless Steel Refrigerator",
  price: "$899",
  discount: "40% OFF",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/stainless_steel_refrigerator.png",
  description: "Energy-efficient with spacious storage"
}, {
  id: 2,
  name: "Front Load Washer",
  price: "$549",
  discount: "35% OFF",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/front_load_washer.png",
  description: "Quick wash cycles, gentle on fabrics"
}, {
  id: 3,
  name: "Electric Range Oven",
  price: "$649",
  discount: "30% OFF",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/electric_range_oven.png",
  description: "Convection cooking with precise controls"
}, {
  id: 4,
  name: "Built-In Dishwasher",
  price: "$449",
  discount: "38% OFF",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/built_in_dishwasher.png",
  description: "Quiet operation with multiple wash settings"
}];
export default function FeaturedAppliances() {
  const [api, setApi] = useState<any>(null);
  const [isHovered, setIsHovered] = useState(false);
  const autoplayRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (!api) return;
    const startAutoplay = () => {
      autoplayRef.current = setInterval(() => {
        if (!isHovered) {
          api.scrollNext();
        }
      }, 3500);
    };
    startAutoplay();
    return () => {
      if (autoplayRef.current) {
        clearInterval(autoplayRef.current);
      }
    };
  }, [api, isHovered]);
  return;
}